import React, { useEffect } from 'react';
import TopBar from '../../Components/TopBar';
import Footer from '../../Components/Footer';
import { Link } from 'react-router-dom';
import { pageView } from '../../Utilities/GoogleAnalytics';

const CollegeFinderIcon = 'https://res.cloudinary.com/stamped/image/upload/v1608735323/SVGs/collegefinger_l5n9lv.svg';
const PRIcon = 'https://res.cloudinary.com/stamped/image/upload/v1608735327/SVGs/pr_fn3fpt.svg';
const TimelineIcon = 'https://res.cloudinary.com/stamped/image/upload/v1608735327/SVGs/timeline_nc3cda.svg';

const TitleSection = () => {
  return (
    <>
      <div className="flex flex-col-reverse items-center h-auto pt-20 bg-altBack lg:flex-row lg:pt-32">
        <div className="w-full p-12 text-center lg:p-0">
          <h1 className="text-3xl font-bold text-brandcolor font-brand lg:text-5xl">Official Stamped Tools</h1>
          <p className="w-full text-gray-700 lg:w-2/5 lg:m-auto text-md lg:text-xl font-brand">
            {' '}
            Stamped is building tools for students and immigrants. Save time spent on planning and researching. Get costs, timelines and information
            about colleges in one place.
          </p>
        </div>
      </div>
    </>
  );
};

const ToolsGrid = () => {
  return (
    <>
      <div className="items-center justify-center pt-3 bg-altBack lg:flex-wrap lg:flex lg:flex-3 lg:pt-12">
        <Link to="/tools/college-finder">
          <div className="m-1 mt-3 mb-3">
            <div className="max-w-sm pt-5 pb-5 pl-10 pr-10 m-auto transition-all duration-200 bg-white rounded-lg shadow-sm cursor-pointer hover:shadow-md">
              <div className="flex">
                <div className="h-full">
                  <p className="text-xl font-bold"> College Finder </p>
                  <p className="pt-2 text-xs"> Find information about major Canadian colleges and universities on an interactive map.</p>
                  <div className="w-2/3 pt-1 pb-1 pl-1 pr-1 mt-5 text-xs font-bold text-center text-white rounded rounded-md shadow cursor-pointer bg-brandcolor font-brand">
                    Go To College Finder
                  </div>
                </div>
                <div className="">
                  <img alt="College Finder Tool" src={CollegeFinderIcon} />
                </div>
              </div>
            </div>
          </div>
        </Link>
        <Link to="/tools/timeline">
          <div className="flex m-1 mt-3 mb-3">
            <div className="max-w-sm pt-5 pb-5 pl-10 pr-10 m-auto transition-all duration-200 bg-white rounded-lg shadow-sm cursor-pointer hover:shadow-md">
              <div className="flex">
                <div className="h-full">
                  <p className="text-xl font-bold"> Timeline Generator </p>
                  <p className="pt-2 text-xs"> Visualize and plan your journey to Canada. Get an estimate of all costs sorted by priority.</p>
                  <div className="w-2/3 pt-1 pb-1 pl-1 pr-1 mt-5 text-xs font-bold text-center text-white rounded rounded-md shadow cursor-pointer bg-brandcolor font-brand">
                    Go To Timeline
                  </div>
                </div>
                <div className="">
                  <img alt="Timeline" src={TimelineIcon} />
                </div>
              </div>
            </div>
          </div>
        </Link>
        <Link to="#">
          <div className="m-1 mt-3 mb-3">
            <div className="max-w-sm pt-5 pb-5 pl-10 pr-10 m-auto transition-all duration-200 bg-white rounded-lg shadow-sm cursor-pointer hover:shadow-md">
              <div className="flex">
                <div className="h-full">
                  <p className="text-xl font-bold"> PR Journey </p>
                  <p className="pt-2 text-xs">
                    {' '}
                    Calculate your points for PR in Canada and visualize your journey. For Canada's Express Entry Program.
                  </p>
                  <div className="w-2/3 pt-1 pb-1 pl-1 pr-1 mt-5 text-xs font-bold text-center text-white rounded rounded-md shadow opacity-25 cursor-pointer bg-brandcolor font-brand">
                    Coming Soon
                  </div>
                </div>
                <div className="">
                  <img alt="PR Icon" src={PRIcon} />
                </div>
              </div>
            </div>
          </div>
        </Link>
      </div>
    </>
  );
};

export default function Tools() {
  //On load, let us punch some pageview
  useEffect(() => {
    pageView(window.location.pathname);
  }, []);

  return (
    <div className="min-h-screen bg-altBack">
      <TopBar />
      <TitleSection />
      <ToolsGrid />
      <div className="lg:absolute lg:bottom-0 lg:left-0 lg:right-0">
        <Footer />
      </div>
    </div>
  );
}
